//Prepare utils for text measurment
let canvas, context

function getTextWidth(inputText, font) {
    canvas || (canvas = document.createElement("canvas"))
    context || (context = canvas.getContext("2d"))

    context.font = font
    context.fontKerning = 'none';
    const width = context?.measureText(inputText).width

    return width ? Math.ceil(width) : undefined
}

/**
 * Takes element and resize its text to fit its width (works only for the longest line)
 * @param {HTMLElement} element
 */
function resizeTextToFit(element) {
    const fontSize = parseFloat(window.getComputedStyle(element, null).getPropertyValue("font-size"));
    const font = window.getComputedStyle(element, null).getPropertyValue("font");

    const splited = element.innerText.split(" ");
    splited.sort((a, b) => b.length - a.length);

    const lognestText = splited[0];

    if (element.clientWidth < getTextWidth(lognestText, font)) {
        let fontSizeCurrent = fontSize;
        let currentFontInfo = window.getComputedStyle(element, null).getPropertyValue("font");

        while ((element.clientWidth) < getTextWidth(lognestText, currentFontInfo) && fontSizeCurrent > 4) {
            fontSizeCurrent -= 2;
            element.style.fontSize = `${fontSizeCurrent}px`;
            currentFontInfo = window.getComputedStyle(element, null).getPropertyValue("font");
        }
    }
}

export { resizeTextToFit }